import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-grow":"1"} }
const _hoisted_2 = { id: "table-head" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { style: {"display":"flex"} }
const _hoisted_5 = { class: "column-header" }
const _hoisted_6 = ["onMouseup"]
const _hoisted_7 = { class: "sort-display-container" }
const _hoisted_8 = {
  key: 2,
  class: "sort-position"
}
const _hoisted_9 = ["onMousedown"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["name"]
const _hoisted_12 = {
  key: 0,
  class: "table-row-footer"
}
const _hoisted_13 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_14 = { class: "loading-content" }
const _hoisted_15 = {
  key: 1,
  class: "empty-container"
}
const _hoisted_16 = { class: "empty-content" }
const _hoisted_17 = {
  key: 0,
  class: "side-pane-head"
}
const _hoisted_18 = { class: "side-pane-content" }
const _hoisted_19 = {
  key: 0,
  class: "pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_pagination = _resolveComponent("b-pagination")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "table-container",
    class: _normalizeClass(['table-container', {'is-dragging': _ctx.isDragging, 'min-height': _ctx.minTableHeight }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "b-table table-responsive",
        style: _normalizeStyle([_ctx.tableClass])
      }, [
        _createElementVNode("table", {
          class: _normalizeClass(['table', {'table-hover': _ctx.hasRowClick}]),
          style: _normalizeStyle({tableLayout: _ctx.isTableFixed() ? 'fixed' : ''})
        }, [
          _createElementVNode("thead", {
            class: "b-table-head",
            style: _normalizeStyle([_ctx.headClass])
          }, [
            _createElementVNode("tr", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnKeys, (key, index) => {
                return (_openBlock(), _createElementBlock("th", {
                  id: `th-${key}`,
                  key: index,
                  style: _normalizeStyle({width: _ctx.getColumnWidthByKey(key, _ctx.fitToPage)}),
                  scope: "col",
                  class: _normalizeClass([{ 'no-cursor': _ctx.getIgnoreSortByKey(key) }])
                }, [
                  _renderSlot(_ctx.$slots, `head(${key})`, {}, () => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", {
                          class: "column-head-title",
                          onMouseup: () => _ctx.sortByTableColumn(key)
                        }, _toDisplayString(_ctx.getColumnDataByKey(key).label), 41, _hoisted_6),
                        (!!_ctx.getColumnDataByKey(key).headerBadge)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getColumnDataByKey(key).headerBadge), {
                              key: 0,
                              class: "header-badge"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        (_ctx.sortDirection(key) === 'ascending')
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 0,
                              icon: "fa-solid fa-arrow-up"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sortDirection(key) === 'descending')
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 1,
                              icon: "fa-solid fa-arrow-down"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.sortArray.length > 1 && _ctx.sortPosition(key) > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.sortPosition(key)), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "table-column-slider",
                      onMousedown: ($event: any) => (_ctx.startDrag(key, $event))
                    }, null, 40, _hoisted_9)
                  ], true)
                ], 14, _hoisted_3))
              }), 128))
            ])
          ], 4),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedItems, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass({'striped': _ctx.striped && (_ctx.toggleRow || _ctx.singleSelect ? !_ctx.state.highlightedRows.includes(index) : true), 'highlightRow' : _ctx.state.highlightedRows.includes(index) }),
                style: _normalizeStyle({height: _ctx.rowHeight}),
                onClick: () => _ctx.onRowClick(item, index)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfColumns, (num) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: "col-slot",
                    key: num,
                    name: `td(${_ctx.getColumnDataByIndex(num - 1).key})`
                  }, [
                    _renderSlot(_ctx.$slots, `cell(${_ctx.getColumnDataByIndex(num - 1).key})`, { item: item }, () => [
                      _createTextVNode(_toDisplayString(_ctx.getColumnDataForUI(num - 1, item as object)), 1)
                    ], true),
                    (_ctx.addTableFooter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_11))
                }), 128))
              ], 14, _hoisted_10))
            }), 128))
          ])
        ], 6),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _renderSlot(_ctx.$slots, "loading", {}, () => [
                  _createVNode(_component_b_spinner)
                ], true)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.showEmpty && _ctx.items.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _renderSlot(_ctx.$slots, "empty", {}, () => [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "EMPTY STATE", -1))
                ], true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 4),
      (_ctx.hasSidePane)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "side-pane-container",
            style: _normalizeStyle({minWidth: _ctx.computedSidePaneOptions.width, borderLeft: '1px solid $gray-400', ..._ctx.tableClass})
          }, [
            (!_ctx.computedSidePaneOptions.hideHeader)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _renderSlot(_ctx.$slots, "side-pane-head", {}, () => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.computedSidePaneOptions.title), 1)
                    ], true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _renderSlot(_ctx.$slots, "side-pane", {}, undefined, true)
            ])
          ], 4))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPagination)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_b_pagination, {
            modelValue: _ctx.currentPage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
            "total-rows": _ctx.filteredItems.length,
            "per-page": _ctx.perPage
          }, null, 8, ["modelValue", "total-rows", "per-page"])
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_vShow, _ctx.show]
  ])
}